export const ACTIVE_MEMBERSHIP = 1;

export const dateFormats = [
  'MM/dd/yyyy',
  'dd/MM/yyyy',
  'MM-dd-yyyy',
  'MM.dd.yyyy',
  'MMMM dd, yyyy',
  'MM-dd-yyyy hh:mm a',
  'MM/dd/yyyy hh:mm:ss a',
  'dd-MM-yyyy',
  'dd.MM.yyyy',
  'dd MM yyyy',
  'yyyy-MM-dd',
  'yyyy/MM/dd',
  'yyyy.MM.dd',
  'dd MMMM yyyy',
  'dd-MM-yyyy HH:mm',
  'dd/MM/yyyy HH:mm:ss',
  "yyyy-MM-dd'T'HH:mm:ss",
  "yyyy-MM-dd'T'HH:mm:ss.SSS",
  "yyyy-MM-dd'T'HH:mm:ssXXX",
  "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
  "yyyy-'W'ww",
  "yyyy-'W'ww-e",
  'yyyy-ddd',
  'yyyy-MM-dd H:mm:ss',
  'yyyy-MM-dd HH:mm:ss',
];
